export default {
    /** File Control */
    file_control: {
        heading: 'FILE CONTROL',
        info_text: `
            <ul class="file-control-info-text">
                <li><span class="bold">Select or drag-and-drop</span> a file in the container below</li>
                <li>The files must either be a <span class="bold">'log'</span>, <span class="bold">'jou'</span>, <span class="bold">'json'</span> or <span class="bold">'zip'</span> type</li>
                <li>A file must not exceed 30MB in size</li>
                <li>Log files must only contain 8 digits in its name, e.g. 20250521.log or 21052025e.log</li>
                <li>After clicking on ‘<span class="bold">UPLOAD</span>’, the chosen files will be uploaded onto an Azure blob-container, where they will be analyzed</li>
                <li>You can select <span class="bold">individual files</span> from the list below to reduce the results displayed</li>
                <li>An <span class="bold">overview</span> can be found on the bottom left of the page, while the <span class="bold">detailed results</span> will be posted on the right side</li>
                <li>You can <span class="bold">download the results</span> as 'jou' file on the bottom left of the page</li>
            </ul>
            `,
        drag_and_drop: `Drag & Drop or<br>click to select a file`,
        file_selected_click_add: `{count} File selected (click or drag and drop to add more)`,
        files_selected_click_add: `{count} Files selected (click or drag and drop to add more)`,
        file_selected_reset: `{count} File selected (reset to add new files)`,
        files_selected_reset: `{count} Files selected (reset to add new files)`,
        reset_files: 'RESET FILES',
        reset_page: 'RESET ALL',
        upload: 'UPLOAD',
        uploaded_files: 'UPLOADED FILES',
        remove_selection: 'REMOVE SELECTION',
        threshold_input: `
            <p style="margin:0 10px 6px; font-size:16px; font-weight:bold">RESPONSE TIME THRESHOLD</p>
            <p style="margin:0 10px">Maximum allowed response time between Checkin and Checkout of Transactions in seconds.</p>
            <p style="margin:0 10px">Leave empty to use the default of 10s.</p>
            `
    },

    /** Result View */
    result_view: {
        journal: 'JOURNAL ANALYSIS',
        log: 'LOG ANALYSIS',
        cases: 'BUSINESS CASES',
        tax: 'TAX GROUPS',
        version: 'VERSION HISTORY',
        responsetimeanalysis: 'RESPONSE TIMES',
        please_upload_file: 'Please upload a file on the left side.',
        copy: 'Copy',
        copied: 'Copied content to clipboard',
        journal_analysis: {
            no_errors: 'No journal errors were found',
            no_errors_selected: 'No journal errors were found in the selected file',
            errorcode: 'Errorcode',
            amount: 'Amount',
            tl_tt_tn: 'TL | TT | TN',
            sq: 'SQ',
            date_time: 'Date, Time',
            message: 'Message',
            clear_btn: 'Clear Selection',
            searchbar_placeholder: 'Search by message ...',
            datepicker_placeholder: 'Filter by date',
        },
        log_analysis: {
            no_errors: 'No log errors were found',
            no_errors_selected: 'No log errors were found in the selected file',
            errorcode: 'Errorcode',
            amount: 'Amount',
            date_time: 'Date, Time',
            message: 'Message',
            clear_btn: 'Clear Selection',
            searchbar_placeholder: 'Search by message ...',
            datepicker_placeholder: 'Filter by date',
        },
        business_cases: {
            type: 'Type',
            amount: 'Amount'
        },
        tax_groups: {
            no_data: 'No data was found',
            no_data_selected: 'No data was found in the selected file',
            taxg: 'Tax Group',
            percent: '%',
            amount: 'Gross Amount',
            tax: 'Tax',
            net: 'Net Amount',
        },
        version_history: {
            no_data: 'No data was found',
            no_data_selected: 'No data was found in the selected file',
            efr_version: 'EFR Version',
            countries: 'Countries',
            date: 'Date',
            time: 'Time',
        },
        response_time_analysis: {
            no_errors: 'No data was found',
            no_errors_selected: 'No data was found in the selected file',
            datepicker_placeholder: 'Filter by date',
            day_file: 'Day / File',
            avg: 'Average',
            topten: '10 Longest',
            unresolved: 'Unresolved',
            exceeded: 'Exceeded Threshold'
        }
    },

    /** General Information */
    summary_control: {
        general_information: 'GENERAL INFORMATION',
        records_analyzed: 'Records Analyzed',
        total_amount: 'Total Amount',
        journal_errors: 'Journal Errors',
        log_errors: 'Log Errors',
        save_text: 'SAVE RESULT AS JOURNAL FILE'
    },

    fileUpload: {
        fileSizeSingleError: "Size of file {file} exceeds limit of 30MB!",
        fileSizeMultipleError: "Size of files {files} exceed limit of 30MB!",

        logFileNameSingleError: "Filename '{file}' does not match the expected format!",
        logFileNameMultipleError: "Filenames {files} do not match the expected format!",
        logFileNameHint: "Expected: YYYYMMDD.log or YYYYMMDDe.log. Files with other names are skipped by the analyzer. Rename them and add them again.",

        noFilesAccepted: "The upload did not contain any file the analyzer can process.",
        unreadableResponse: "The server response could not be read (it may have been cut off). Please try again.",
        uploadRejected: "The upload was rejected (HTTP {status}): {message}",
        uploadFailed: "The upload failed: {message}",
        noFileToAnalyze: "No file to analyze!",

        analyzeFailed: "{file} could not be analyzed: {reason}",
        analyzeFailedAll: "None of the uploaded files could be analyzed.",
        reasonHttp: "the server responded with HTTP {status}",
        reasonUnreadable: "the server response could not be read (it may have been cut off)",
        reasonNetwork: "network error ({message})"
    }
}